<template>
  <!-- MODAL PowerMeter -->
  <b-modal
    id="modalPowerMeter"
    size="xl"
    title="Graph PowerMeter"
    ok-only
    @hidden="resetModal"
  >
    <!-- Gauge -->
    <b-row align-h="center">
      <b>สถานที่ :</b> {{ Devbuilding }}
    </b-row>
    <b-row align-h="center">
      <b-col cols="6">
        <div class="text-center">
          <b> แรงดันไฟฟ้า </b>
        </div>
        <VueSvgGauge
          :start-angle="-110"
          :end-angle="110"
          :value="Volt"
          :separator-step="0"
          :min="0"
          :max="300"
          :gauge-color="[{ offset: 0, color: '#E77C43'}, { offset: 100, color: '#FF0000'}]"
          :scale-interval="0.1"
          style="height: 180px;"
        >
          <div
            align="center"
            class="inner-text"
          >
            <span><b> {{ Volt }} </b></span>
          </div>
        </VueSvgGauge>
      </b-col>

      <b-col
        cols="6"
      >
        <div class="text-center">
          <b> กระแสไฟฟ้า </b>
        </div>
        <VueSvgGauge
          :start-angle="-110"
          :end-angle="110"
          :value="Amp"
          :separator-step="0"
          :min="0"
          :max="100"
          :gauge-color="[{ offset: 0, color: '#1A8EE7'}, { offset: 100, color: '#51EBC0'}]"
          :scale-interval="0.1"
          style="height: 180px;"
        >
          <div
            align="center"
            class="inner-text"
          >
            <span style="color: #1A8EE7;"><b> {{ Amp }} </b></span>
          </div>
        </VueSvgGauge>
      </b-col>
    </b-row>
    <!-- //Gauge -->
    <hr style="border-top: 1px solid #BFBFBF; margin: 15px;">
    <b-row>
      <!-- Graph Volt -->
      <b-col cols="6">
        <span style="padding-left: 25px; padding: 10px; text-align: left; font-size:14px;">กราฟแสดงแรงดันภายใน 24 ชั่วโมง (Volt)</span>
        <hr style="border-top: 1px solid #ffffff; margin:0;">
        <app-echart-line-volt
          :option-data="option2"
        />
      </b-col>
      <!-- //Graph Volt -->

      <!-- Graph Amp -->
      <b-col cols="6">
        <span style="padding-left: 25px; text-align: left; font-size:14px;">กราฟแสดงกระแสไฟฟ้าภายใน 24 ชั่วโมง (Amp)</span>
        <hr style="border-top: 1px solid #ffffff; margin:0;">
        <app-echart-line-amp-today
          :option-data="option"
        />
      </b-col>
      <!-- //Graph Amp -->
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol,
  // BFormFile,
} from 'bootstrap-vue'
import { VueSvgGauge } from 'vue-svg-gauge'
// import AppEchartLine from '@core/components/charts/echart/AppEchartLine.vue'
import AppEchartLineAmpToday from '@core/components/charts/echart/AppEchartLineAmpToday.vue'
import AppEchartLineVolt from '@core/components/charts/echart/AppEchartLineVolt.vue'

export default {
  components: {
    BRow,
    BCol,
    // AppEchartLine,
    VueSvgGauge,
    AppEchartLineAmpToday,
    AppEchartLineVolt,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    cont: Number,
  },
  data() {
    return {
      editData: {
        id: '',
        devtype: '',
        devbrand: '',
        devmodel: '',
        // icon: '',
      },
      Devbuilding: '',
      Volt: '',
      Amp: '',
      selectedID: '',
      selectedFile: null,
      option: {
        xAxisData: [],
        grid: {
          show: false,
          containLabel: false,
          borderWidth: '1px',
          left: '160px',
          right: '15px',
          bottom: '25px',
          top: '25px',
        },
        series: [
          {
            type: 'line',
            stack: 'Total',
            areaStyle: {
              color: '#299aff',
            },
            color: '#299aff',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      option2: {
        xAxisData: [],
        series: [
          {
            type: 'line',
            stack: 'Total',
            areaStyle: {
              color: '#FF7A33',
            },
            color: '#FF7A33',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
  },
  methods: {
    resetModal() {
      this.option.series[0].data = []
      this.option.xAxisData = []
      this.option2.series[0].data = []
      this.option2.xAxisData = []
    },
    getGraphPowerMeter(devid) {
      this.selectedID = devid
      axios
        .post('/get-graphPowerMeter', { devid: this.selectedID })
        .then(response => {
          this.xAxisData = []
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.option.xAxisData.push(value.PeriodName)
            this.option2.xAxisData.push(value.PeriodName)
            this.option.series[0].data.push(value.amp)
            this.option2.series[0].data.push(value.volt)
          })
          console.log(this.option.xAxisData)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getPowerMeter(devid) {
      this.selectedID = devid
      axios
        .post('/get-gaugePowerMeter', { devid: this.selectedID })
        .then(response => {
          this.Devbuilding = response.data[0].devbuilding
          this.Volt = response.data[0].volt
          this.Amp = response.data[0].amp
          this.getGraphPowerMeter(devid)
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
.inner-text {

  display: flex;
  justify-content: center;
  margin-top: 85px;
  font-size: 20px;
  color: #de3a21;
  font-weight: bold;
}
div.text-center {
  text-align: center;
}
</style>
